import { trpc } from '@web-app/utils/trpc';

/** Healthie date of birth and weight/height evidence for the Bridge review. */
export function useMedicareBridgeClinicalPrefill(
  patientHealthieId: string | null | undefined,
  { enabled }: { enabled: boolean },
) {
  const id = patientHealthieId ?? '';
  return trpc.medicareBridge.getClinicalPrefill.useQuery(
    { patientHealthieId: id },
    { enabled: enabled && /^\d+$/.test(id), retry: false },
  );
}
